<ng-container *ngIf="(surveyViewerService.activeSurvey$ | async).form.get(this.question.key)">
  <div id="matrixFormSmall" data-testId="radioMatrixFormSmall" *ngIf="isSmallScreen">
    <div *ngFor="let rowKey of question.rowsOrder" data-testId="matrixRowMobile">
      <img *ngIf="surveyViewerService.getRowLabelImageUrl(question, rowKey, activeLang) && question.useImage"
           src="{{surveyViewerService.getRowLabelImageUrl(question, rowKey, activeLang)}}"
           alt="image" [style.width]="question.imageSize+'px'"
           class="image-label">

      <ng-container [formGroup]="$any(questionFormControl.get(rowKey).get(question.formControlName))">

        <div class="matrix-statement-title">{{ question.rows[rowKey].label | translateLabel: activeLang }}</div>

        <div *ngFor="let sKey of isReversedStatements" data-testId="statementMobile">

          <ng-container>
            <mat-radio-group
              [color]="'primary'"
              [formControlName]="sKey"
              aria-labelledby="radio-group-label"
              class="vertical-matrix-selection"
            >
              <mat-radio-button
                (change)="question.resetPreviousRadioStatementFormSelection(rowKey, sKey, questionFormControl)"
                [value]="true"
                class="selection-input"
                data-testId="matrixRadioBtnMobile"
              >
                <mat-label>
                  <img
                    *ngIf="surveyViewerService.getStatementLabelImageUrl(question, sKey, activeLang) && question.useImage"
                    src="{{surveyViewerService.getStatementLabelImageUrl(question, sKey, activeLang)}}"
                    alt="image" [style.width]="question.imageSize+'px'"
                    class="image-label"
                  >
                  {{ question.statements[sKey].label | translateLabel: activeLang }}
                </mat-label>
              </mat-radio-button>

              <ng-container *ngIf="questionFormControl.get(rowKey).get(question.commentsControlName).get(sKey) && questionFormControl.get(rowKey).get(question.formControlName).get(sKey).value">
                <mat-form-field [color]="'primary'" appearance="outline" class="w-full selection-comment">
                  <mat-label>{{ 'Expliquez votre choix'|transloco }}
                    ({{ (question.rows[rowKey].label | translateLabel: activeLang) + ': ' + (question.statements[sKey].label | translateLabel: activeLang) }}
                    )
                  </mat-label>
                  <input appNoPaste [errorStateMatcher]="errorMatcher" type="text" matInput
                         [formControl]="$any(questionFormControl.get(rowKey).get(question.commentsControlName).get(sKey))"
                         (input)="onInput($event.target.value, sKey, rowKey)"
                         (blur)="onBlur($event.target.value.trim(), sKey, rowKey)">
                  <mat-error>
                    {{ 'Le commentaire ne peut être vide'|transloco }}.
                  </mat-error>
                </mat-form-field>
                <ng-container *ngIf="isValidAi?.[rowKey]?.[sKey]| async as isValidAi">
                  <div class="warning-message mb-8" *ngIf="!isValidAi.isValid">**** {{isValidAi.explication}}</div>
                </ng-container>
              </ng-container>

            </mat-radio-group>
          </ng-container>

        </div>
      </ng-container>
    </div>

    <ng-container *ngIf="surveyViewerService.allFormControlsMarkedAsTouched$.value && questionFormControl.errors">
      <mat-error *ngIf="questionFormControl.hasError(surveyViewerService.requireSelectionForEachStatementFnName)">
        {{ 'Une sélection doit être faite pour chaque ligne.'|transloco }}
      </mat-error>

      <mat-error *ngIf="questionFormControl.hasError(surveyViewerService.minRowErrorFnName)">
        {{ surveyViewerService.errorMessages.minRowSelection(question.minAnswers.rows) | translateLabel: activeLang }}
      </mat-error>

      <mat-error *ngIf="questionFormControl.hasError(surveyViewerService.minStatementErrorFnName)">
        {{ surveyViewerService.errorMessages.minStatementSelection(question.minAnswers.statements) | translateLabel: activeLang }}
      </mat-error>
    </ng-container>

  </div>

  <div data-testId="radioMatrixForm" *ngIf="!isSmallScreen">
    <div id="matrixFormBig">
      <div>
      </div>
      <ng-container *ngFor="let sKey of question.statementsOrder">
        <div data-testId="matrixStatement" class="columnLabel">
          <img
            *ngIf="surveyViewerService.getStatementLabelImageUrl(question, sKey, activeLang) && question.useImage"
            src="{{surveyViewerService.getStatementLabelImageUrl(question, sKey, activeLang)}}"
            alt="image" [style.width]="question.imageSize+'px'"
            class="image-label"
          >
          <div>
            {{ question.statements[sKey].label | translateLabel: activeLang }}
          </div>
        </div>
      </ng-container>
    </div>
    <div id="matrixFormBigRows">
      <div class="rowsContainer">
        <div *ngFor="let rowKey of question.rowsOrder" data-testId="matrixRow" class="matrixRow">
          <ng-container [formGroup]="$any(questionFormControl.get(rowKey).get(question.formControlName))">
            <div class="rowLabel">
              <img
                *ngIf="surveyViewerService.getRowLabelImageUrl(question, rowKey, activeLang) && question.useImage"
                src="{{surveyViewerService.getRowLabelImageUrl(question, rowKey, activeLang)}}"
                alt="image" [style.width]="question.imageSize+'px'"
                class="image-label"
              >
              {{ question.rows[rowKey].label | translateLabel: activeLang }}
            </div>
            <div *ngFor="let sKey of question.statementsOrder" class="selectionContainer">
              <mat-radio-group
                [color]="'primary'"
                [formControlName]="sKey"
                aria-labelledby="radio-group-label"
                class="vertical-radio-group"
              >
                <mat-radio-button
                  (change)="question.resetPreviousRadioStatementFormSelection(rowKey, sKey, questionFormControl)"
                  [value]="true"
                  class="radio-input"
                  data-testId="matrixRadio"
                >
                </mat-radio-button>
              </mat-radio-group>
            </div>
          </ng-container>
        </div>
      </div>
    </div>

    <ng-container *ngIf="surveyViewerService.allFormControlsMarkedAsTouched$.value && questionFormControl.errors">
      <mat-error *ngIf="questionFormControl.hasError(surveyViewerService.requireSelectionForEachStatementFnName)">
        {{ 'Une sélection doit être faite pour chaque ligne.'|transloco }}
      </mat-error>

      <mat-error *ngIf="questionFormControl.hasError(surveyViewerService.minRowErrorFnName)">
        {{ surveyViewerService.errorMessages.minRowSelection(question.minAnswers.rows) | translateLabel: activeLang }}
      </mat-error>

      <mat-error *ngIf="questionFormControl.hasError(surveyViewerService.minStatementErrorFnName)">
        {{ surveyViewerService.errorMessages.minStatementSelection(question.minAnswers.statements) | translateLabel: activeLang }}
      </mat-error>
    </ng-container>

    <ng-container *ngFor="let rKey of question.rowsOrder">
      <ng-container *ngFor="let sKey of question.statementsOrder">
        <ng-container *ngIf="questionFormControl.get(rKey).get(question.commentsControlName).get(sKey) && questionFormControl.get(rKey).get(question.formControlName).get(sKey).value">
          <mat-form-field [color]="'primary'" appearance="outline" class="w-full"
          >
            <mat-label>{{ 'Expliquez votre choix'|transloco }}
              ({{ (question.rows[rKey].label | translateLabel: activeLang) + ': ' + (question.statements[sKey].label | translateLabel: activeLang) }}
              )
            </mat-label>
            <input appNoPaste [errorStateMatcher]="errorMatcher" type="text" matInput
                   [formControl]="$any(questionFormControl.get(rKey).get(question.commentsControlName).get(sKey))"
                   (input)="onInput($event.target.value, sKey, rKey)"
                   (blur)="onBlur($event.target.value.trim(), sKey, rKey)">
            <mat-error>
              {{ 'Le commentaire ne peut être vide'|transloco }}.
            </mat-error>
          </mat-form-field>
          <ng-container *ngIf="isValidAi?.[rKey]?.[sKey]| async as isValidAi">
            <div class="warning-message mb-8" *ngIf="!isValidAi.isValid">**** {{isValidAi.explication}}</div>
          </ng-container>
        </ng-container>
      </ng-container>
    </ng-container>
  </div>
</ng-container>
